import { signal } from '@angular/core';
import { DynamicComponentDirective, FeatureRootComponentsService, takeWhileAlive } from '@core/frontend-shared';
import * as i0 from "@angular/core";
import * as i1 from "@core/frontend-shared";
function CoreRootOutletComponent_For_1_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function CoreRootOutletComponent_For_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, CoreRootOutletComponent_For_1_ng_container_0_Template, 1, 0, "ng-container", 0);
  }
  if (rf & 2) {
    const componentInfo_r1 = ctx.$implicit;
    i0.ɵɵproperty("dynamicComponent", componentInfo_r1);
  }
}
export let CoreRootOutletComponent = /*#__PURE__*/(() => {
  class CoreRootOutletComponent {
    constructor(service) {
      this.componentInfos = signal([], ...(ngDevMode ? [{
        debugName: "componentInfos"
      }] : /* istanbul ignore next */[]));
      service.getRootComponents$().pipe(takeWhileAlive()).subscribe(components => {
        this.componentInfos.set(components);
      });
    }
    static {
      this.ɵfac = function CoreRootOutletComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || CoreRootOutletComponent)(i0.ɵɵdirectiveInject(i1.FeatureRootComponentsService));
      };
    }
    static {
      this.ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
        type: CoreRootOutletComponent,
        selectors: [["core-root-outlet"]],
        decls: 2,
        vars: 0,
        consts: [[4, "dynamicComponent"]],
        template: function CoreRootOutletComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵrepeaterCreate(0, CoreRootOutletComponent_For_1_Template, 1, 1, "ng-container", null, i0.ɵɵrepeaterTrackByIdentity);
          }
          if (rf & 2) {
            i0.ɵɵrepeater(ctx.componentInfos());
          }
        },
        dependencies: [DynamicComponentDirective],
        encapsulation: 2
      });
    }
  }
  return CoreRootOutletComponent;
})();